import React, {useState, useCallback} from "react";
import { useLocation } from "react-router-dom";
import { Frame } from "@shopify/polaris";
import Routes from "../Routes";
import AdminNavigation from "./components/AdminNavigation";
import AdminTopBar from "./components/AdminTopBar";
import CustomForms from "../Forms";
import CovidSubscriptionForm from "../Forms/FirstCare/CovidSubscriptionForm";

function AppFrame() {
  const [mobileNavigationActive, setMobileNavigationActive] = useState(false);
  const toggleMobileNavigationActive = useCallback(
    () =>
      setMobileNavigationActive(
        (mobileNavigationActive) => !mobileNavigationActive,
      ),
    [],
  );
  const location = useLocation();
  console.log(mobileNavigationActive)
  if (location.pathname === "/CovidForm") {
    return <CustomForms/>;
  } else {
    return (
      <Frame
        navigation={<AdminNavigation />}
        topBar={<AdminTopBar onNavigationToggle={toggleMobileNavigationActive} />}
        showMobileNavigation={mobileNavigationActive}
        onNavigationDismiss={toggleMobileNavigationActive}
      >
        <Routes />
      </Frame>
    );
  }
}
export default AppFrame;